import PurpleRadialGradientBackground from "@/components/background/purple-radial-gradient";
import { cn } from "@/utils/cn";
import { FormEventHandler, memo } from "react";

interface OnboardingFormCardContainerProps {
  children: React.ReactNode;
  classNames?: {
    container?: string;
    image?: string;
    form?: string;
  };
  onSubmit?: FormEventHandler<HTMLFormElement>;
}

export const OnboardingFormCardContainer = memo(function OnboardingFormCardContainer({
  children,
  onSubmit,
  classNames,
}: OnboardingFormCardContainerProps) {
  return (
    <PurpleRadialGradientBackground
      classNames={{
        container: cn(
          "flex-1 w-full rounded-t-[56px] px-8 border-t-3 border-white shadow-[0_4px_24px_0_rgba(0,0,0,0.10)_inset]",
          classNames?.container,
        ),
        image: cn("bottom-0", classNames?.image),
      }}
    >
      <form
        className={cn("z-10 flex w-full flex-col gap-4.5 py-9", classNames?.form)}
        onSubmit={onSubmit}
      >
        {children}
      </form>
    </PurpleRadialGradientBackground>
  );
});
